import { useContext } from 'react'
import { MainNavigateContext } from '../context/MainNavigateContext'
import type { MainNavigate } from '../typings/MainNavigate'

export function useMainNavigate(): MainNavigate {
  return useContext(MainNavigateContext)!
}
